<div class="px-4 pb-2">
	<p-skeleton height="1.2rem" width="5rem" />
</div>
<ic-restrictive-measure-list-skeleton />
<div class="p-4">
	<p-skeleton height="0.1rem" width="100%" />
</div>
<div class="px-4 pb-2">
	<p-skeleton height="1.2rem" width="5rem" />
</div>
<ic-restrictive-measure-list-skeleton />
